import {
  type AccessoriesHistoryStateType,
  type FilterHistoryStateType,
} from '@vs-shop/schemas/history/filterHistoryState';

export const ourFilterData: {
  categoryFilters?: FilterHistoryStateType;
  accessoriesFilters?: AccessoriesHistoryStateType;
} = {};

let originalReplaceState: typeof history.replaceState | null = null;

function patchHistoryReplaceState(): void {
  if (typeof window === 'undefined' || originalReplaceState !== null) return;

  originalReplaceState = window.history.replaceState.bind(window.history);

  window.history.replaceState = function (
    data: unknown,
    unused: string,
    url?: string | URL | null
  ) {
    const mergedData =
      data && typeof data === 'object' ? { ...data, ...ourFilterData } : { ...ourFilterData };

    if (originalReplaceState) {
      originalReplaceState.call(this, mergedData, unused, url);
      return;
    }
  };
}

if (typeof window !== 'undefined') {
  patchHistoryReplaceState();
}
